import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { AssignedBijlage } from '../types/AssignedBijlage'
import type { Bijlage } from '../types/Bijlage'

export { cancelBijlageForEntity }

const cancelBijlageForEntity = async ({
  entity: { type, id },
  bijlageInfo: { _id },
  isAssigned,
}: {
  entity: Entity
  bijlageInfo: Bijlage | AssignedBijlage
  isAssigned: boolean
}): Promise<Bijlage | AssignedBijlage> => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/bijlage${isAssigned ? 'assigned' : ''}/${_id}`,
    method: 'PATCH',
    data: { status: 'cancelled' },
  })

  return data
}
